import {useFormik} from 'formik';
import {useState} from 'react';
import {CreatePartnerDTO, usePartners} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseAddPartnerFormProps = {
  setOpen: (open: boolean) => void;
};

export const useAddPartnerForm = ({setOpen}: UseAddPartnerFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {createPartnerMutation} = usePartners();

  const onSubmit = async (values: any) => {
    setErrorMessage(null);
    try {
      const formattedValues: CreatePartnerDTO = {
        title: values.title,
        description: values.description || null,
        priority: values.priority,
        website: values.website || null,
        logoUploadId: values.logoUploadId,
      };

      await createPartnerMutation.mutateAsync(formattedValues);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при создании партнера');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: '',
      description: '',
      priority: 1,
      website: '',
      logoUploadId: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Название не должно превышать 256 символов').required('Название обязательно'),
      description: Yup.string().max(1000, 'Описание не должно превышать 1000 символов').nullable(),
      priority: Yup.number().min(1, 'Приоритет должен быть минимум 1').required('Приоритет обязателен'),
      website: Yup.string().url('Введите корректный URL').nullable(),
      logoUploadId: Yup.string().required('Логотип обязателен'),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: createPartnerMutation.isPending,
    submitError: createPartnerMutation.error
      ? (createPartnerMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
